import React from 'react'
// import { Grid } from '@material-ui/core'
import DataPanels from './DataPanels'
import Responses from './Responses'

export default () => (
	<div>
		<DataPanels />
		<Responses />
	</div>
)
